export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.safety": "Safety",
  "nav.faq": "FAQ",
  "nav.visit": "Visit Main Website",

  "hero.badge": "Independent resource hub",
  "hero.title": "USFans Spreadsheet — Your Complete Guide to USFans Shopping",
  "hero.subtitle": "Looking for a USFans spreadsheet, shopping guide or reliable information before you buy? You're in the right place. Explore organized resources, product guides, shipping information, warehouse tips, QC advice, reviews and safety guides — all in one easy-to-navigate hub.",
  "hero.cta_primary": "Explore USFans Spreadsheet",
  "hero.cta_secondary": "Read the USFans Guide",
  "hero.trust": "Independent resource · Updated guides · Practical information · Safety-focused",
  "hero.search_placeholder": "Search spreadsheet guides, shipping, QC, coupons…",
  "hero.table_title": "Sample spreadsheet layout",
  "hero.col_product": "Product",
  "hero.col_category": "Category",
  "hero.col_reference": "Reference",
  "hero.col_qc": "QC",
  "hero.col_shipping": "Shipping",
  "hero.col_status": "Status",
  "hero.item_1": "Item 01",
  "hero.item_2": "Item 02",
  "hero.item_3": "Item 03",
  "hero.item_4": "Item 04",
  "hero.qc_pending": "Pending",
  "hero.qc_passed": "Passed",
  "hero.ship_standard": "Standard",
  "hero.ship_express": "Express",
  "hero.status_considering": "Considering",
  "hero.status_ordered": "Ordered",
  "hero.status_received": "Received",

  "main.buy_now": "Buy It Now",
  "main.tagline": "Browse the full collection on our main website",
  "main.note": "All product links open in a new tab on our main website.",

  "category.title": "Shop by Category",
  "category.subtitle": "Jump straight to any product category on the main website.",
  "category.dropdown_label": "Choose a category",
  "category.dropdown_placeholder": "Select a category to visit",

  "what_is.title": "What Is a USFans Spreadsheet?",
  "what_is.body": "A USFans spreadsheet is a structured resource that helps shoppers organize and discover product information. Our goal is to make that information easier to understand by collecting practical guides, product-related resources, shipping explanations, QC tips and useful references in one place.",
  "what_is.cta": "Explore the Spreadsheet Hub",

  "features.title": "Everything You Need to Know About USFans",
  "features.subtitle": "Start here to understand the platform before you shop.",
  "features.spreadsheet.title": "USFans Spreadsheet",
  "features.spreadsheet.desc": "Explore spreadsheet resources and learn how to navigate product information.",
  "features.review.title": "USFans Review",
  "features.review.desc": "Understand the platform, shopping process, potential advantages and things to consider.",
  "features.shipping.title": "USFans Shipping Cost",
  "features.shipping.desc": "Learn what can influence shipping costs and how to compare available options.",
  "features.coupon.title": "USFans Coupon",
  "features.coupon.desc": "Find out where to look for current promotions and how discount information should be verified.",
  "features.warehouse.title": "USFans Warehouse",
  "features.warehouse.desc": "Understand the warehouse process, storage, QC and shipment preparation.",
  "features.legit.title": "Is USFans Legit?",
  "features.legit.desc": "Review practical safety checks and questions to consider before using any shopping service.",

  "guides.title": "Start With the Most Popular Guides",
  "guides.subtitle": "Hand-picked resources to help you shop with confidence.",
  "guides.card1": "USFans Spreadsheet Guide",
  "guides.card2": "USFans Review",
  "guides.card3": "USFans Shipping Cost Guide",
  "guides.card4": "USFans Coupon Guide",
  "guides.card5": "USFans Warehouse Guide",
  "guides.card6": "Is USFans Legit?",

  "why.title": "Why Use This Resource?",
  "why.subtitle": "Built to make your shopping research easier and safer.",
  "why.1.title": "Organized information",
  "why.1.desc": "Everything grouped in one clear, logical structure.",
  "why.2.title": "Beginner-friendly",
  "why.2.desc": "Plain-language explanations for every level.",
  "why.3.title": "Comparison tables",
  "why.3.desc": "See options side by side before you decide.",
  "why.4.title": "Updated content",
  "why.4.desc": "Guides reviewed and refreshed regularly.",
  "why.5.title": "Safety-focused",
  "why.5.desc": "Practical checks to help you shop responsibly.",
  "why.6.title": "Multilingual",
  "why.6.desc": "Available in English, Polish, Spanish and French.",

  "compare.title": "Compare Before You Decide",
  "compare.body": "Different shopping methods, shipping options and workflows can involve different costs, requirements and risks. Use our comparison guides to understand the differences before making a decision.",
  "compare.cta": "View USFans Comparisons",

  "safety.title": "Safety First",
  "safety.body": "Online shopping involves risks. Always verify current information, payment details, shipping policies and seller information before making a purchase.",
  "safety.cta": "Read the USFans Safety Guide",

  "homeArticle.title": "Latest Guide",
  "homeArticle.subtitle": "Read our in-depth beginner's guide to the USFans Spreadsheet.",
  "homeArticle.cta": "Read the full guide",
  "homeArticle.read_time": "Read time: 6 min",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is a USFans spreadsheet?",
  "faq.a1": "A USFans spreadsheet is a structured resource that helps shoppers organize and discover product information in one place.",
  "faq.q2": "Is this the official USFans website?",
  "faq.a2": "No. This is an independent information and resource platform. We are not affiliated with or endorsed by any specific seller.",
  "faq.q3": "How do I browse products?",
  "faq.a3": "Use the category menu or the buttons above to jump directly to any product category on the main website.",
  "faq.q4": "Do you list prices or coupons?",
  "faq.a4": "We share general guidance only. Always verify current prices, promotions and shipping details directly on the main website.",

  "final.title": "Ready to Explore USFans Spreadsheet Resources?",
  "final.body": "Start with the spreadsheet, compare your options and learn the basics before you buy.",
  "final.cta_primary": "Explore USFans Spreadsheet",
  "final.cta_secondary": "Visit Main Website",

  "footer.description": "An independent multilingual resource hub about the USFans Spreadsheet. We share guides, reviews and practical shopping information to help you make informed decisions.",
  "footer.resources": "Resources",
  "footer.company": "Company",
  "footer.legal": "Legal",
  "footer.languages": "Languages",
  "footer.about": "About",
  "footer.editorial": "Editorial Policy",
  "footer.contact": "Contact",
  "footer.disclaimer": "Disclaimer",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.cookies": "Cookies",
  "footer.disclaimer_text": "This is an independent information website. We are not the official USFans store and do not sell products directly. All product links lead to the main website.",
  "footer.copyright": "© 2026 USFans Spreadsheet Resource Hub. All rights reserved.",
};